export const types = {
  SYNC_HEALTH_RECORDS: 'syncHealthRecords',
  VERIFY_PROFILE_DETAILS: 'verifyProfileDetails',
  SYNC_STATUS: 'syncStatus',
  IDENTITY_VERIFICATION_STATUS: 'identityVerificationStatus',
  IDENTITY_VERIFIED_STATUS: 'identityVerifiedStatus'
};
